import isEmpty from "lodash-es/isEmpty";
import { Button, RemoveIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { Key } from "antd/lib/table/interface";
import { SharedserviceMelcoModelsAlphabetListItem } from "melco-shared-logic";
import { useAddFonts } from "../../../hooks/libraries/fontCollections/useAddFonts";

type BulkActionRemoveFontsProps = {
  allFonts: SharedserviceMelcoModelsAlphabetListItem[];
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
};

export const BulkActionRemoveFonts: React.FC<BulkActionRemoveFontsProps> = ({
  allFonts,
  selectedRowKeys,
  setSelectedRowKeys,
}) => {
  const { t } = useTranslation();

  const { removeFonts } = useAddFonts();

  if (isEmpty(selectedRowKeys)) {
    return null;
  }

  return (
    <Button
      key="bulk-remove"
      icon={<RemoveIcon />}
      onClick={() => {
        const toRemove = allFonts.filter(
          (f) => f.id && selectedRowKeys.includes(f.id)
        );

        removeFonts(toRemove);

        setSelectedRowKeys([]);
      }}
    >
      {t("font_collections.actions.add_fonts.actions.remove")}
    </Button>
  );
};
